import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { IntegrationPartner } from 'src/app/models/ManageIntegrationModel';
import { PlatformApiService, ResultFilter, Results } from 'src/app/services/platform-api.service';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'cw-ci-admin-integration-partner-list',
  templateUrl: './integration-partner-list.component.html',
  styleUrls: []
})
export class IntegrationPartnerListComponent implements OnInit {
  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(DataTableComponent, { static: true }) integrationPartnerDataTable: DataTableComponent;
  integrationPartnerList: Results;

  constructor(private _platformApi: PlatformApiService, public dialog: MatDialog) { }

  ngOnInit() {

  }

  isSelectable(item: IntegrationPartner) {
    return true;
  }

  addIntegrationPartner(event?) {
    this.stateChange.emit({ state: 'CREATE' });
  }

  editIntegrationPartner(item: IntegrationPartner) {
    this.stateChange.emit({ state: 'EDIT', item });
  }

  loadIntegrationPartners(filter = new ResultFilter()) {
    this.integrationPartnerDataTable.showProcessing();
    const listObservable = this._platformApi.getIntegrationPartners(filter);
    listObservable.subscribe(results => {
      this.integrationPartnerList = results;
    })
  }
}
